import React, { useContext } from 'react';

import { RenderRowProps, TableInstanceContext } from '@bringg-frontend/bringg-react-table';

const ColumnLabelsTableRow: React.FC<RenderRowProps> = ({ index, style }) => {
	const { prepareRow, rows } = useContext(TableInstanceContext);
	const row = rows[index];
	prepareRow(row);

	const { key: rowKey, style: rowStyle, ...rowProps } = row.getRowProps({ style });

	return (
		<div
			key={rowKey ?? row.id}
			{...rowProps}
			style={{ ...rowStyle, width: '100%' }}
			className="table-row"
			data-test-id={`column-label-row-${row.original.id}`}
		>
			{row.cells.map(cell => {
				const { key: cellKey, style: cellStyle, ...cellProps } = cell.getCellProps();

				return (
					<div
						key={cellKey ?? cell.column.id}
						{...cellProps}
						className="table-data-cell"
						style={{ ...cellStyle, display: 'flex', alignItems: 'center' }}
					>
						<div className="cell-data">{cell.render('Cell')}</div>
					</div>
				);
			})}
		</div>
	);
};

export default ColumnLabelsTableRow;
